var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about van-hairline--top"},[_c('h1',{on:{"click":_vm.showToast}},[_vm._v("This is an about page")])])}
var staticRenderFns = []

export { render, staticRenderFns }